import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchDeleteCostReport } from '../services/patchDeleteCostReport.service';

export const deleteCostReport = createAsyncThunk(
  'expenseTracking/deleteCostReport',
  async ({ reportPK }, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    if (!selectedProjectId) {
      throw new Error('No project id given');
    }

    await patchDeleteCostReport(selectedProjectId, { reportPK });

    return reportPK;
  }
);
